import { NgModule } from '@angular/core';

import { ModalErrorComponent } from './modal-error.component';

@NgModule({
  imports: [ModalErrorComponent],
  exports: [ModalErrorComponent],
  declarations: [],
  providers: [],
})
export class ModalErrorModule { }
